export const Role_Customer = "customer";
export const Role_Discord = "discord";
export const AppUrl = "https://app.marketaction.live";
//export const AppUrl = "http://localhost:3000";